/**
 * SpecialtyPharmacyPriorAuthStatusSection - Output section for SP prior auth status
 *
 * Displays specialty pharmacy prior authorization status as a top-level accordion section.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface SpecialtyPharmacyPriorAuthStatusSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
}

export const SpecialtyPharmacyPriorAuthStatusSection: React.FC<
  SpecialtyPharmacyPriorAuthStatusSectionProps
> = ({ data, sectionId }) => {
  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>Drug Specialty Pharmacy Prior Auth Status</span>
          <SectionTriggerScore subsectionKey="specialty_pharmacy_prior_auth_status" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix="drug.specialty_pharmacy_prior_auth_status">
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="PA Required"
              value={data?.specialty_pharmacy_prior_authorization_required}
              fieldId="specialty_pharmacy_prior_authorization_required"
            />
            <Field
              label="Same PA Process"
              value={data?.specialty_pharmacy_same_prior_authorization_process}
              fieldId="specialty_pharmacy_same_prior_authorization_process"
            />
            <Field
              label="Reference Number"
              value={data?.specialty_pharmacy_prior_authorization_reference_number}
              fieldId="specialty_pharmacy_prior_authorization_reference_number"
            />
            <Field
              label="Effective Date"
              value={data?.specialty_pharmacy_prior_authorization_effective_date}
              fieldId="specialty_pharmacy_prior_authorization_effective_date"
            />
            <Field
              label="End Date"
              value={data?.specialty_pharmacy_prior_authorization_end_date}
              fieldId="specialty_pharmacy_prior_authorization_end_date"
            />
            <Field
              label="Quantity Limits"
              value={data?.specialty_pharmacy_prior_authorization_quantity_limits}
              fieldId="specialty_pharmacy_prior_authorization_quantity_limits"
            />
            <Field
              label="Quantity Used"
              value={data?.specialty_pharmacy_prior_authorization_quantity_limits_used}
              fieldId="specialty_pharmacy_prior_authorization_quantity_limits_used"
            />
            <Field
              label="PA On File Exists"
              value={data?.specialty_pharmacy_prior_authorization_on_file_exists}
              fieldId="specialty_pharmacy_prior_authorization_on_file_exists"
            />
            <Field
              label="PA On File"
              value={data?.specialty_pharmacy_prior_authorization_on_file}
              fieldId="specialty_pharmacy_prior_authorization_on_file"
            />
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
